import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[treeEmptyResultsTemplate]',
  standalone: true,
})
export class TreeEmptyResultsTemplateDirective {
  @Input('treeEmptyResultsTemplate') name!: string; // e.g. "status", "link"

  constructor(public template: TemplateRef<unknown>) {}
}
